module.exports = __webpack_public_path__ + "static/media/Runs.ceced8ae.png";